var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.LightOn-st0 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\r\n\t\t.LightOn-st1 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "LightOn-st0",
    d: "M8.8,13.1c-0.3,0-0.4,0-0.6-0.1c-0.1-0.1-0.2-0.2-0.3-0.5L6.4,9.2C6.2,8.6,6,8.3,6.2,8.1 c0.1-0.2,0.5-0.2,1.1-0.2h9.3c0.6,0,1,0,1.1,0.2s0,0.5-0.2,1.1l-1.6,3.3c-0.1,0.3-0.2,0.4-0.3,0.5c-0.1,0.1-0.3,0.1-0.6,0.1H8.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "LightOn-st0",
    d: "M6.1,7.2c0-0.2,0.2-0.4,0.5-0.4h10.8c0.3,0,0.5,0.2,0.5,0.4v0.4H6.1V7.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "LightOn-st0",
    d: "M8.2,12.6h7.5v10.8H8.2V12.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "LightOn-st1",
    d: "M10.5,17.6c0-0.7,0.6-1.3,1.4-1.3s1.4,0.6,1.4,1.3v0.9c0,0.7-0.6,1.3-1.4,1.3s-1.4-0.6-1.4-1.3V17.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "LightOn-st0",
    d: "M3.5,2.7l1.3-1.3l3.7,3.5L7.1,6.2L3.5,2.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "LightOn-st0",
    d: "M18.8,1.4l1.3,1.3l-3.6,3.5l-1.3-1.3L18.8,1.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "LightOn-st0",
    d: "M11,0.5h1.9v4.9H11V0.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightOn);
export default __webpack_public_path__ + "static/media/LightOn.6ade0303855a99c1ccd0c8d51f791732.svg";
export { ForwardRef as ReactComponent };